<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block" style="padding-right: 300px;">
        <div class="zv-breadcrumb-wrap style-2">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-input/collectDataList' }"
              >信息管理</el-breadcrumb-item
            >
            <el-breadcrumb-item>信息详情页</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="collect-data-main">
          <div class="zv-flex-wrap collect-data-item">
            <div class="zv-form-item-label">资讯标题:</div>
            <div class="zv-flex-1">
              <div class="zv-form-item-content paddint-b-10">
                {{ dataInfo.title }}
              </div>
              <div class="paddint-b-10">
                <el-button
                  type="primary"
                  size="mini"
                  @click="translateContentClick"
                  >翻译</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  class="btn-copy"
                  @click="copyText(dataInfo.title)"
                  >复制标题</el-button
                >
              </div>
              <el-input v-if="isTranslate" v-model="translateTitle" class="paddint-b-10"></el-input>
              <div class="paddint-t-10">
                <el-button
                  v-if="isTranslate"
                  type="primary"
                  size="mini"
                  class="btn-copy"
                  @click="copyText(translateTitle)"
                  >复制编辑结果</el-button
                >
              </div>
            </div>
          </div>
          <div class="zv-flex-wrap collect-data-item">
            <div class="zv-form-item-label">报道时间:</div>
            <div class="zv-flex-1">
              <div class="zv-form-item-content">
                {{ dataInfo.publish_time | formatDate }}
              </div>
            </div>
          </div>
          <div class="zv-flex-wrap collect-data-item">
            <div class="zv-form-item-label">采集时间:</div>
            <div class="zv-flex-1">
              <div class="zv-form-item-content">
                {{ dataInfo.add_time | formatDate }}
              </div>
            </div>
          </div>
          <div class="zv-flex-wrap collect-data-item">
            <div class="zv-form-item-label">正文:</div>
            <div class="zv-flex-1">
              <div
                class="zv-form-item-content paddint-b-10"
                style="word-break:break-all;word-wrap:break-word"
                v-html="dataInfo.content"
              >
                <!-- {{ dataInfo.content }} -->
              </div>
              <!-- <div
                class="zv-form-item-content paddint-b-10"
                v-show="isTranslate"
              >
                {{ translateContent }}
              </div> -->
              <div style="margin-bottom: 10px">
                <el-button
                  type="primary"
                  size="mini"
                  @click="translateContentClick"
                  v-if="!isTranslate"
                  >翻译</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="showNormalContent"
                  v-if="isTranslate"
                  >正文</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  class="btn-copy"
                  @click="copyText(dataInfo.copy_content)"
                  v-if="!isTranslate"
                  >复制全文</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  class="btn-copy"
                  @click="copyText(translateContent)"
                  v-if="isTranslate"
                  >复制全文</el-button
                >
              </div>
              <el-input type="textarea" rows="10" v-if="isTranslate" v-model="translateContent" class="paddint-b-10"></el-input>
              <div class="paddint-t-10">
                <el-button
                  v-if="isTranslate"
                  type="primary"
                  size="mini"
                  class="btn-copy"
                  @click="copyText(translateContent)"
                  >复制编辑结果</el-button
                >
              </div>
            </div>
          </div>
          <div class="zv-flex-wrap collect-data-item">
            <div class="zv-form-item-label">图片:</div>
            <div class="zv-flex-1">
              <div class="collect-images-wrap">
                <div
                  class="collect-image-item"
                  v-for="(imageUrl, index) in dataInfo.picture"
                  :key="index"
                >
                  <div class="collect-image-content">
                    <el-image
                      :src="imageUrl"
                      :preview-src-list="[imageUrl]"
                      fit="cover"
                      style="width: 117px; height: 117px;"
                    ></el-image>
                  </div>
                  <div class="collect-image-btns">
                    <el-button
                      type="primary"
                      size="mini"
                      class="btn-copy"
                      @click="copyText(imageUrl)"
                      >复制</el-button
                    >
                    <a
                      :href="imageUrl"
                      download
                      target="_blank"
                      class="el-button btn-copy el-button--primary el-button--mini"
                    >
                      <span>下载</span>
                    </a>
                    <!-- <el-button type="primary" size="mini" @click="$commFunc.downloadImg(imageUrl)">下载</el-button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="zv-flex-wrap collect-data-item">
            <div class="zv-form-item-label">国家:</div>
            <div class="zv-flex-1">
              <div class="zv-form-item-content">{{ dataInfo.area_name }}</div>
            </div>
          </div>
          <div class="zv-flex-wrap collect-data-item">
            <div class="zv-form-item-label">语言:</div>
            <div class="zv-flex-1">
              <div class="zv-form-item-content">{{ dataInfo.language }}</div>
            </div>
          </div>
          <div class="zv-flex-wrap collect-data-item">
            <div class="zv-form-item-label">分类:</div>
            <div class="zv-flex-1">
              <div class="zv-form-item-content">
                {{ dataInfo.cat_id | getSourceTypeName }}
              </div>
            </div>
          </div>
          <div class="zv-flex-wrap collect-data-item">
            <div class="zv-form-item-label">信息源:</div>
            <div class="zv-flex-1">
              <div class="zv-form-item-content">{{ dataInfo.source_name }}</div>
            </div>
          </div>
          <div class="zv-flex-wrap collect-data-item">
            <div class="zv-form-item-label">源地址:</div>
            <div class="zv-flex-1">
              <div class="zv-form-item-content">
                <a :href="dataInfo.source_url" target="_blank">{{
                  dataInfo.source_url
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cdd-status-fixed">
      <div class="cdd-status-sec1">
        <div class="cdd-status-sec1-text1">处理状态：</div>
        <div class="cdd-status-sec1-text2" v-if="dataInfo.status == 0">
          待处理
        </div>
        <div class="cdd-status-sec1-text2 style-dealed" v-else>已处理</div>
      </div>
      <div class="cdd-status-sec2">
        <div class="cdd-status-sec2-text">文章标签：</div>
        <div class="cdd-status-sec22">
          <el-tag
            :key="tag.id"
            v-for="(tag, index) in collectDataTags"
            closable
            size="medium"
            type="success"
            :disable-transitions="false"
            @close="deleteTag(index)"
          >
            {{ tag.tag_name }}
          </el-tag>
        </div>
        <div class="cdd-status-sec23">
          <el-select
            class="input-new-tag"
            v-model="selectTagValue"
            ref="saveTagInput"
            size="mini"
            filterable
            allow-create
            default-first-option
            placeholder="请选择文章标签"
          >
            <el-option
              v-for="item in selectTagsList"
              :key="item.id"
              :label="item.tag_name"
              :value="item.tag_name">
            </el-option>
          </el-select>

          <el-button
            class="button-new-tag"
            size="mini"
            type="primary"
            icon="el-icon-plus"
            @click="addTagClick"
          >
            增加
          </el-button>
        </div>
      </div>

      <div class="cdd-status-sec3">
        <div class="cdd-status-sec3-item">
          <el-button type="primary" @click="dealWithClick" :disabled="dataInfo.status != 0">处理完成</el-button>
        </div>
        <div class="cdd-status-sec3-item">
          <el-button type="default" @click="goBack" style="width: 80px;">返回</el-button>
        </div>
        <div class="cdd-status-sec3-item">
          <el-button type="danger" @click="deleteSourceClick">删除文章</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import api from "./api";
import TipUtil from "@/utils/utils/TipUtil";
import enums from "@/utils/enums";
import formPageMixin from "@/mixins/formPageMixin";
import { setTimeout } from 'timers';
export default {
  name: "CollectDataDetail",
  mixins: [formPageMixin],
  components: {},
  data() {
    let vm = this;
    return {
      id: "", // 信息数据id
      dataInfo: "", // 信息数据详情
      isTranslate: "", // 是否翻译
      translateTitle: "", // 翻译标题
      translateContent: "", // 翻译内容
      selectTagsList: [],  // 下拉列表中的
      inputVisible: false,
      selectTagValue: "",
      collectDataTags: [],  // tag列表
    };
  },
  computed: {},

  methods: {
    async getCollectDataDetail() {
      let resData = await api.collectDataDetail({
        id: this.id
      });

      console.log(resData);
      this.dataInfo = resData.info;
      this.language = resData.info.language
      this.translateContent = resData.info.trans_content
      if(this.translateContent != null) {
        this.isTranslate = true
      }
      let clonedTagArr = this.$_.cloneDeep(this.dataInfo.tags || [])
      this.collectDataTags = clonedTagArr
    },

    async getCollectSourceTagList() {
      let res = await api.collectSourceTagList({})
      this.selectTagsList = res.list
    },

    copyText(data) {
      let clipboard = new Clipboard(".btn-copy", {
        text: function() {
          return data;
        }
      });
      clipboard.on("success", e => {
        TipUtil.message("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        TipUtil.message("复制失败", "error");
        clipboard.destroy();
      });
    },

    // lafite: 2020.05.27 => 1.2.1修改
    async translateContentClick() {
      if(this.language == "阿姆哈拉语" || this.language == "缅甸语" || this.language == "乌兹别克语") {
        var datas = {
          data: this.dataInfo.content,
          lan: this.language
        }
        var titleData = {
          data: this.dataInfo.title,
          lan: this.language
        }
      }else {
        var datas = {
          data: this.dataInfo.content
        }
        var titleData = {
          data: this.dataInfo.title
        }
      }
      let res = await api.collectSourceContentTranslate(datas);
      this.isTranslate = true;
      this.translateContent = res.data;

      setTimeout(async () => {
        let titleRes = await api.collectSourceContentTranslate(titleData);
        this.translateTitle = titleRes.data;
      },1000)
    },

    showNormalContent() {
      this.isTranslate = false;
    },

    deleteTag(index) {
      this.collectDataTags.splice(index, 1);
    },

    async addTagClick() {
      if (this.selectTagValue == '') {
        TipUtil.message('标签名称不能为空', 'error')
        return false
      }

      let findIndex = this.selectTagsList.findIndex(item => item.tag_name == this.selectTagValue)
      // 如果是已在标签列表中
      if (findIndex > -1) {
        let tagItem = this.selectTagsList[findIndex]
        let isExisted = this.collectDataTags.some(item => item.tag_name == this.selectTagValue)
        if (isExisted) {
          TipUtil.message('请勿重复添加标签!')
          return false
        } else {
          this.collectDataTags.push(tagItem)
        }
      } else {
        let res = await api.createCollectSourceTag({
          tag_name: this.selectTagValue
        })
        console.log('rrrrrrr')
        console.log(res)

        this.selectTagsList.push({
          id: res.tag_id,
          tag_name: this.selectTagValue
        })

        this.collectDataTags.push({
          id: res.tag_id,
          tag_name: this.selectTagValue
        })
      }

      this.selectTagValue = ''
    },

    async dealWithClick() {
      await api.editCollectData({
        id: this.id,
        status: 1,
        trans_content: this.translateContent,
        tag_id: this.collectDataTags.map(item => item.id).join(',')
      })
      TipUtil.message('文单处理完成!', 'success')
      this.$set(this.dataInfo, 'status', 1)
    },

    async deleteSourceClick() {
      await this.$confirm(
        '确定删除此文章？',
        '提示',
        {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      await api.editCollectData({
        id: this.id,
        status: 2
      })
      TipUtil.message('删除文章成功!', 'success')
      setTimeout(() => {
        this.$router.back()
      }, 500)
    }
  },
  created() {
    let id = this.$route.query.id;
    if (id) {
      this.id = id;
      this.getCollectDataDetail();
      this.getCollectSourceTagList();
    }
  },
  mounted() {},
  beforeDestroy() {},

  filters: {
    getSourceTypeName(typeId) {
      return enums.CollectSourceType.getName(typeId);
    }
  }
};
</script>

<style lang="less" scoped>
.collect-data-main {
  .zv-form-item-label {
    line-height: inherit;
  }

  .collect-data-item {
    padding: 10px 0;
  }
}

.collect-images-wrap {
  display: flex;
  flex-wrap: wrap;
}
.collect-image-item {
  margin-right: 10px;
  margin-bottom: 10px;
}
.collect-image-content {
  padding-bottom: 5px;
  .el-image {
    display: block;
  }
}

.collect-image-btns {
  .el-button + .el-button {
    margin-left: 5px;
  }
}

.cdd-status-fixed {
  position: fixed;
  background: #fff;
  top: 44px;
  right: 0;
  z-index: 1000;
  width: 250px;
  bottom: 42px;
  border-left: 1px solid #f5f3f3;
  padding: 30px 15px;
}

.cdd-status-sec1-text2 {
  text-align: center;
  font-size: 24px;
  padding: 30px 0 40px;
  color: #67c23a;
  font-weight: bold;
  &.style-dealed {
    color: #909399;
  }
}

// .cdd-status-sec2 {

// }

.cdd-status-sec22 {
  padding-top: 10px;
}

// .cdd-status-sec2-text {

// }

.cdd-status-sec22 {
  .el-tag {
    margin-bottom: 10px;
  }



  .el-tag + .el-tag {
    margin-left: 10px;
  }
}

.cdd-status-sec23 {
  display: flex;
  .button-new-tag{
    margin-left: 10px;
  }
}

.cdd-status-sec3 {
  padding-top: 90px;
}

.cdd-status-sec3-item {
  text-align: center;
  margin-bottom: 10px;
}
</style>
